// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"customElement___wrapper___iGO6K"};